import { Provider } from "@redotech/redo-model/order";
import { ShopifyGraphQLProduct } from "@redotech/redo-model/product";
import { z } from "zod";

export const getProduct = {
  input: z.object({ productId: z.string(), provider: z.nativeEnum(Provider) }),
  output: z.object({ product: ShopifyGraphQLProduct }),
};
